import { LogActivityModal } from "animals/LogActivityModal";
import { GetAnimalsList_animalsExtended_animals } from "api/MyLivestock/Animal/types/GetAnimalsList";
import { Button, Flex } from "components";
// Components
import { MoveGroupOfAnimalsToFieldButton } from "components/MyLivestock";
import { AddSelectedAnimalsToTag } from "components/MyLivestock/Animals/AnimalBulkActions/AddSelectedAnimalsToTag";
import { CreateListingFromSelection } from "components/MyLivestock/Animals/AnimalBulkActions/CreateListingFromSelection";
import { RemoveSelectedAnimalsToTag } from "components/MyLivestock/Animals/AnimalBulkActions/RemoveSelectedAnimalsToTag";
// Utils
import { ELEMENTS_IDS } from "constants/ElementsIds";
import { EDIT_ANIMALS_IN_GROUP_TYPES } from "constants/Groups";
// Resources
import styles from "./styles.module.scss";

interface Props {
  changeEditMode: (type: string | null) => void;
  fetchAllAnimalsList: () => void;
  isButtonVisible?: boolean;
  isEdited?: string | null;
  animals: GetAnimalsList_animalsExtended_animals[] | undefined;
  isBatch?: boolean;
}

const NotEditModeButtons = ({
  isEdited,
  fetchAllAnimalsList,
  isButtonVisible,
  changeEditMode,
  animals,
  isBatch = false,
}: Props): JSX.Element => {
  const handleAddAnimalsToGroup = (): void => {
    if (!isEdited) {
      fetchAllAnimalsList();
    }

    changeEditMode(EDIT_ANIMALS_IN_GROUP_TYPES.ADD_TO_GROUP);
  };

  const groupAnimalsIds = animals?.map((animal) => animal?.id) ?? [];
  return (
    <div className={styles.viewButtons}>
      {!isBatch && animals && animals?.length > 0 ? (
        <Flex item itemGutter>
          <CreateListingFromSelection animals={animals} />
        </Flex>
      ) : null}

      {!isBatch && isButtonVisible ? <MoveGroupOfAnimalsToFieldButton /> : null}
      <Flex item itemGutter>
        <AddSelectedAnimalsToTag animalIds={groupAnimalsIds} />
      </Flex>
      <Flex item itemGutter>
        <RemoveSelectedAnimalsToTag animalIds={groupAnimalsIds} />
      </Flex>

      <Button
        id={ELEMENTS_IDS.GROUP_ADD_ANIMALS_TO_GROUP_BUTTON}
        caption="Add animals to group"
        onClick={handleAddAnimalsToGroup}
      />
      {!isBatch && groupAnimalsIds.length > 0 ? (
        <div className={styles.logActivityButton}>
          <LogActivityModal animalIds={groupAnimalsIds} />
        </div>
      ) : null}
    </div>
  );
};

export default NotEditModeButtons;
